<template>
  <svg
    width="71"
    height="52"
    viewBox="0 0 71 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="71" height="52" fill="white" />
    <path
      opacity="0.8"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M61.7193 6.61998C61.7193 8.72063 60.0164 10.4235 57.9158 10.4235C55.8151 10.4235 54.1122 8.72063 54.1122 6.61998C54.1122 4.51932 55.8151 2.81641 57.9158 2.81641C60.0164 2.81641 61.7193 4.51932 61.7193 6.61998ZM57.3724 26.1812C57.3724 38.6851 47.236 48.8215 34.7321 48.8215C22.2282 48.8215 12.0918 38.6851 12.0918 26.1812C12.0918 13.6773 22.2282 3.5409 34.7321 3.5409C47.236 3.5409 57.3724 13.6773 57.3724 26.1812ZM65.8852 14.4082C66.9855 14.4082 67.8775 13.5162 67.8775 12.4159C67.8775 11.3156 66.9855 10.4235 65.8852 10.4235C64.7848 10.4235 63.8928 11.3156 63.8928 12.4159C63.8928 13.5162 64.7848 14.4082 65.8852 14.4082Z"
      fill="url(#paint0_radial_9931_22881)"
    />
    <path
      d="M24.8357 9.94246C25.0969 8.96783 26.1001 8.38982 27.0765 8.65145L48.7336 14.4544C49.71 14.7161 50.2898 15.7183 50.0287 16.6929L42.8176 43.6049C42.5565 44.5795 41.5532 45.1575 40.5768 44.8959L18.9198 39.0929C17.9434 38.8313 17.3635 37.8291 17.6247 36.8545L24.8357 9.94246Z"
      fill="url(#paint1_radial_9931_22881)"
    />
    <path
      d="M20.7856 12.8426C20.7856 11.8336 21.6051 11.0156 22.6159 11.0156H45.037C46.0478 11.0156 46.8673 11.8336 46.8673 12.8426V40.704C46.8673 41.713 46.0478 42.5309 45.037 42.5309H22.6159C21.6051 42.5309 20.7856 41.713 20.7856 40.704V12.8426Z"
      fill="url(#paint2_radial_9931_22881)"
    />
    <rect
      x="22.959"
      y="15.7246"
      width="10.8673"
      height="1.81122"
      rx="0.72449"
      fill="url(#paint3_radial_9931_22881)"
    />
    <rect
      x="22.959"
      y="18.623"
      width="5.43367"
      height="1.81122"
      rx="0.72449"
      fill="url(#paint4_radial_9931_22881)"
    />
    <rect
      x="22.959"
      y="22.6074"
      width="22.0969"
      height="1.81122"
      rx="0.72449"
      fill="url(#paint5_radial_9931_22881)"
    />
    <rect
      x="22.959"
      y="25.8672"
      width="22.0969"
      height="1.81122"
      rx="0.72449"
      fill="url(#paint6_radial_9931_22881)"
    />
    <rect
      x="22.959"
      y="32.3887"
      width="22.0969"
      height="1.81122"
      rx="0.72449"
      fill="url(#paint7_radial_9931_22881)"
    />
    <rect
      x="22.959"
      y="29.1289"
      width="18.1122"
      height="1.81122"
      rx="0.72449"
      fill="url(#paint8_radial_9931_22881)"
    />
    <rect
      x="22.959"
      y="35.6484"
      width="10.8673"
      height="1.81122"
      rx="0.72449"
      fill="url(#paint9_radial_9931_22881)"
    />
    <g opacity="0.5" filter="url(#filter0_f_9931_22881)">
      <path
        d="M50.7486 19.1654C51.1059 18.5466 51.8972 18.3345 52.516 18.6918V18.6918C53.1348 19.0491 53.3468 19.8403 52.9895 20.4592L42.6554 38.3584C42.6034 38.4485 42.5419 38.5326 42.4719 38.6095L39.6112 41.7513C39.3494 42.0388 38.8801 41.7679 38.9983 41.3974L40.2888 37.3491C40.3204 37.25 40.3625 37.1547 40.4145 37.0647L50.7486 19.1654Z"
        fill="url(#paint10_radial_9931_22881)"
      />
    </g>
    <path
      d="M48.9497 17.4527C49.5001 16.4994 50.7191 16.1727 51.6724 16.7231V16.7231C52.6257 17.2735 52.9523 18.4925 52.402 19.4458L41.9928 37.4751C41.9172 37.606 41.8215 37.7243 41.7094 37.8257L37.8991 41.2687C37.6382 41.5044 37.2283 41.2677 37.302 40.924L38.3786 35.9027C38.4103 35.7548 38.4649 35.6129 38.5405 35.4819L48.9497 17.4527Z"
      fill="url(#paint11_radial_9931_22881)"
    />
    <path
      d="M48.9497 17.4527C49.5001 16.4994 50.7191 16.1727 51.6724 16.7231V16.7231C52.6257 17.2735 52.9523 18.4925 52.402 19.4458L42.0844 37.3164L38.6321 35.3232L48.9497 17.4527Z"
      fill="url(#paint12_linear_9931_22881)"
    />
    <defs>
      <filter
        id="filter0_f_9931_22881"
        x="37.5305"
        y="17.0686"
        width="17.0816"
        height="26.2515"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="0.72449"
          result="effect1_foregroundBlur_9931_22881"
        />
      </filter>
      <radialGradient
        id="paint0_radial_9931_22881"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(58.3821 -9.3188) rotate(117.452) scale(71.2326 75.1265)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_9931_22881"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32.593 30.3899) rotate(-75) scale(20.5866 28.0154)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_9931_22881"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(53.2066 49.9569) rotate(-129.519) scale(50.9498 55.7931)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_9931_22881"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.0279 16.5383) rotate(4.3184) scale(14.2928 2.90539)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_9931_22881"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(23.4934 19.4368) rotate(8.58828) scale(7.20694 2.88099)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_9931_22881"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.1325 23.4212) rotate(2.12685) scale(28.9996 2.91165)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_9931_22881"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.1325 26.6809) rotate(2.12685) scale(28.9996 2.91165)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_9931_22881"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.1325 33.2024) rotate(2.12685) scale(28.9996 2.91165)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_9931_22881"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.7405 29.9426) rotate(2.59418) scale(23.7781 2.91067)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_9931_22881"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(24.0279 36.4622) rotate(4.3184) scale(14.2928 2.90539)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint10_radial_9931_22881"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(47.5425 27.3397) rotate(119.929) scale(54.203 4.9332)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.99407" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint11_radial_9931_22881"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.0634 51.9747) rotate(-62.9665) scale(46.6822 11.117)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <linearGradient
        id="paint12_linear_9931_22881"
        x1="39.0789"
        y1="38.3669"
        x2="36.3413"
        y2="36.3936"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </linearGradient>
    </defs>
  </svg>
</template>
